<template>
  <div class="side-frame-container">
    <slot />
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
$side-frame-width: 350px;

.side-frame-container {
  position: absolute;
  top: 30px;
  right: 30px;
  width: $side-frame-width;
  min-width: 270px;
  max-height: calc(100vh - 60px);
  overflow-y: scroll;
  box-shadow: 0 0 8px 4px rgba(0, 0, 0, 0.6);

  .mobile & {
    min-width: unset;
    min-height: unset;
    top: 0;
    right: 0;
    z-index: 60;
    width: 100%;
  }
}
</style>
